import { useQuery } from 'react-query';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { IImageThumbnail } from '../../../Entities';

export type CommentTime = {
    localDateTime: string;
    originalDateTime?: string | null;
};

export type ImageComment = {
    id: number;
    author: string;
    text: string;
    time: CommentTime;
    toPhotographer: boolean;
    toImageEditor: boolean;
    toSe360: boolean;
};

export type ImageVersion = {
    id: number;
    reference: string;
    highResImageReference: string | null;
    filename: string;
    time: string;
    parentId: number | null;
    needsEditing: boolean;
    hasComments: boolean;
    commentModel: {
        comments: ImageComment[];
    } | null;
    width: number;
    height: number;
    fileSize: number;
    dpi: number;
    category: number;
    canDelete: boolean;
};

export type EditedImageDetails = {
    imageShowcaseViewModels: ImageVersion[];
    thumbnail: IImageThumbnail;
};

type EditedImageQueryArgs = {
    orderId: number;
    imageId: number | null;
    user: AuthenticatedUser;
};

export let editedImageQueryKey = 'image-editor-image-processing-edited-image';

export function getEditedImageQueryKey(orderId: number, imageId: number | null) {
    return [editedImageQueryKey, { orderId, imageId }];
}

export function useEditedImageQuery({ orderId, imageId, user }: EditedImageQueryArgs) {
    let { logger } = useTelemetryContext();

    let { data, isLoading } = useQuery<EditedImageDetails>(
        getEditedImageQueryKey(orderId, imageId),
        () => ImageProcessingApi.getEditedImage(orderId, imageId),
        {
            enabled: imageId !== null,
            useErrorBoundary: true,
            onError: (error) => {
                logger.logException(error, {
                    origin: 'ImageEditorImageProcessingPage.Query.getEditedImage',
                    userInfo: getUserInfo(user),
                    imageId
                });
            }
        }
    );

    return { data: data != null ? data : null, isLoading };
}
